import React, { useState } from "react";
import { Colors } from "../../Constants/colors";
import { useDispatch, useSelector } from "react-redux";
import {
  setShowSideMenuBar,
  setSideMenuOption,
} from "../../Redux/Slices/sideMenu.slice";
import { RootState } from "../../Redux/store";
import { useNavigate } from "react-router-dom";
import { isUserRoleValidForNavigation } from "../../roleConfig";

interface Props {
  // allowedRoles: string[];
  title: string;
  onClick?: () => unknown;
  icon: {
    src: string;
    alt: string;
  };
  navigateTo?: string;
  subButtons?: { name: string; onClick?: () => unknown; navigateTo?: string }[];
}

// Add a permission here.
const SideMenuBtn = ({
  title,
  onClick,
  icon,
  navigateTo,
  subButtons,
}: Props) => {
  const [subButtonClickedIndex, setSubButtonClickedIndex] = useState<
    number | null
  >(null);

  const dispatch = useDispatch();

  const navigation = useNavigate();

  const buttonClicked = useSelector((state: RootState) => ({
    title: state.sideMenu.title,
    isClicked: state.sideMenu.isClicked,
  }));

  const { role } = useSelector((state: RootState) => state.user);

  let isButtonVisible = false;

  if (navigateTo) {
    isButtonVisible = isUserRoleValidForNavigation({
      path: navigateTo,
      userRole: role,
    });
  } else if (subButtons?.length) {
    subButtons.forEach((button) => {
      if (
        isUserRoleValidForNavigation({
          path: button?.navigateTo,
          userRole: role,
        })
      ) {
        isButtonVisible = true;
        return;
      }
    });
  }

  if (!isButtonVisible) {
    return <></>;
  }

  return (
    <div>
      <div
        className="w-full h-14 flex justify-center"
        style={{
          backgroundColor: Colors.CrimsonRed,
          borderBottom: `1px solid ${Colors.BurgundyRed}`,
          color: Colors.White,
          cursor: "pointer",
        }}
        onClick={() => {
          onClick && onClick();
          navigateTo && navigation(navigateTo);
          dispatch(setSideMenuOption(title));
          !!!subButtons && dispatch(setShowSideMenuBar(false));
        }}
      >
        <div className="flex flex-row items-center w-4/5">
          <div className="w-8">
            <img
              src={icon.src}
              alt={icon.alt}
              style={{ width: "18px", height: "18px" }}
            />
          </div>
          <div className="w-44">{title}</div>
          {subButtons && subButtons.length ? (
            <>
              <div
                style={{
                  marginLeft: 0,
                  flex: 1,
                  display: "flex",
                  justifyContent: "flex-end",
                }}
              >
                <svg
                  width="9"
                  height="9"
                  viewBox="0 0 8 12"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  className={
                    buttonClicked?.title === title &&
                    buttonClicked.isClicked &&
                    subButtons
                      ? "sideArrow"
                      : ""
                  }
                >
                  <path
                    d="M0.589996 10.59L5.17 6L0.589996 1.41L2 0L8 6L2 12L0.589996 10.59Z"
                    // fill="#9EA8B5"
                    fill={
                      buttonClicked?.title === title && buttonClicked.isClicked
                        ? Colors.TangerineOrange
                        : Colors.White
                    }
                  />
                </svg>
              </div>
            </>
          ) : (
            <></>
          )}
        </div>
      </div>
      {/* THESE ARE SUBBUTTONS */}
      {subButtons && (
        <div
          className="subButtonWrapper"
          style={
            buttonClicked.isClicked && buttonClicked.title === title
              ? //THIS IS VERY CRITICAL CODE IF THE HEIGHT OF THE SUB BUTTONS IS CHANGED THEN 56 SHOULD ALSO BE CHANGED
                { maxHeight: `${subButtons.length * 56}px` }
              : { maxHeight: 0 }
          }
        >
          {subButtons.map((buttons, index) => {
            const isSubButtonVisible = isUserRoleValidForNavigation({
              path: buttons?.navigateTo,
              userRole: role,
            });

            if (!isSubButtonVisible) {
              return <></>;
            }

            return (
              <div
                className="py-2 w-full h-14 flex items-center"
                style={{
                  backgroundColor: Colors.BurgundyRed,
                  color: Colors.White,
                  cursor: "pointer",
                }}
                key={index}
              >
                <div
                  className="w-full h-10 flex justify-center items-center"
                  style={{
                    backgroundColor:
                      subButtonClickedIndex === index ? Colors.CrimsonRed : "",
                  }}
                  onClick={() => {
                    setSubButtonClickedIndex(index);
                    buttons.navigateTo && navigation(buttons.navigateTo);
                    buttons.onClick && buttons.onClick();
                    dispatch(setShowSideMenuBar(false));
                  }}
                >
                  <div className="w-4">
                    <svg
                      width="9"
                      height="9"
                      viewBox="0 0 8 12"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M0.589996 10.59L5.17 6L0.589996 1.41L2 0L8 6L2 12L0.589996 10.59Z"
                        fill="#9EA8B5"
                      />
                    </svg>
                  </div>
                  <div className="w-44">{buttons.name}</div>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default SideMenuBtn;
